import equal from "fast-deep-equal/es6";
function useGridRowSelection({
  rows,
  selectedItems,
  onSelectionModelChange,
  onSelect
}) {
  const selectionModel = selectedItems?.map((i) => i?.id)?.sort();
  const rowSelectionModel = {
    type: "include",
    ids: new Set(selectionModel)
  };
  function handleModelChange(rowSelectionModel2) {
    const newSelectedIds = [];
    if (rowSelectionModel2.type === "include") {
      newSelectedIds.push(...rowSelectionModel2.ids);
    } else {
      newSelectedIds.push(...rows.map((r) => r.id).filter((id) => rowSelectionModel2.ids.has(id)));
    }
    if (!equal(selectionModel, newSelectedIds)) {
      if (onSelectionModelChange) {
        onSelectionModelChange({ selectionModel: newSelectedIds });
      }
      if (onSelect) {
        onSelect(newSelectedIds);
      }
    }
  }
  return {
    disableRowSelectionOnClick: true,
    onRowSelectionModelChange: handleModelChange,
    rowSelectionModel
  };
}
export {
  useGridRowSelection
};
//# sourceMappingURL=useGridRowSelection.js.map
